import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'

import { Btn, CustomCalendar, CustomPanel, PageHeader } from '../../../../components'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import { urlReportUtilizacaoSistema } from '../../../../services/api/routes/system.routes'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'

function UtilizacaoSistema({ history }) {
  // estados locais

  const [pInicial, setPInicial] = useState(getPeriodoMesAtual().dataInicial)
  const [pFinal, setPFinal] = useState(getPeriodoMesAtual().dataFinal)

  const onGerarRelatorioClick = () => {
    if (!pInicial || !pFinal) {
      alert('Preencha as datas Inicial e Final.')
      return
    }

    const userId = getUsuarioInfo().id

    const dataInicial = parseToMysqlFormat(pInicial)
    const dataFinal = parseToMysqlFormat(pFinal)

    const url = urlReportUtilizacaoSistema(dataInicial, dataFinal, userId)
    window.open(url, '_blank')
  }

  return (
    <React.Fragment>
      <PageHeader>S.28&nbsp;- Grau de Utilização do Sistema</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid" style={{ alignItems: 'flex-end' }}>
            <CustomCalendar
              label="Período Inicial"
              value={pInicial}
              onChange={value => {
                setPInicial(value)
              }}
            />
            <CustomCalendar
              label="Período Final"
              value={pFinal}
              onChange={value => {
                setPFinal(value)
              }}
            />

            <div className="p-col-2" style={{ paddingBottom: 8 }}>
              <Btn onClick={onGerarRelatorioClick}>Gerar Relatório</Btn>
            </div>
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UtilizacaoSistema)
